export default __webpack_public_path__ + "static/media/VeggieFruit_08.12acadb1.png";